import { render, staticRenderFns } from "./mensaje_secretario.vue?vue&type=template&id=6a4c7d82&scoped=true"
import script from "./mensaje_secretario.vue?vue&type=script&lang=js"
export * from "./mensaje_secretario.vue?vue&type=script&lang=js"
import style0 from "./mensaje_secretario.vue?vue&type=style&index=0&id=6a4c7d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c7d82",
  null
  
)

export default component.exports